import "core-js/modules/es.function.name.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-5316ac1f"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "Tab"
};
var _hoisted_2 = {
  class: "scrollbar-flex-content"
};
var _hoisted_3 = {
  style: {
    "vertical-align": "middle"
  }
};

var _hoisted_4 = /*#__PURE__*/_createTextVNode("刷新");

var _hoisted_5 = /*#__PURE__*/_createTextVNode("关闭右侧标签");

var _hoisted_6 = /*#__PURE__*/_createTextVNode("全部关闭");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_location_filled = _resolveComponent("location-filled");

  var _component_el_icon = _resolveComponent("el-icon");

  var _component_el_tag = _resolveComponent("el-tag");

  var _component_el_dropdown_item = _resolveComponent("el-dropdown-item");

  var _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");

  var _component_el_dropdown = _resolveComponent("el-dropdown");

  var _component_el_scrollbar = _resolveComponent("el-scrollbar");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_scrollbar, null, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.tags, function (tag, index) {
        return _openBlock(), _createBlock(_component_el_dropdown, {
          onCommand: $options.meuns,
          onContextmenu: function onContextmenu($event) {
            return $options.context(index);
          },
          trigger: "contextmenu",
          class: _normalizeClass(_ctx.$route.name == tag.name ? 'bai' : ''),
          key: index
        }, {
          dropdown: _withCtx(function () {
            return [_createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(function () {
                return [_createVNode(_component_el_dropdown_item, {
                  icon: $setup.RefreshLeft,
                  command: {
                    num: 1,
                    path: tag,
                    index: index
                  }
                }, {
                  default: _withCtx(function () {
                    return [_hoisted_4];
                  }),
                  _: 2
                }, 1032, ["icon", "command"]), _createVNode(_component_el_dropdown_item, {
                  icon: $setup.Close,
                  command: {
                    num: 2,
                    path: tag,
                    index: index
                  },
                  disabled: $data.tags.length == index + 1
                }, {
                  default: _withCtx(function () {
                    return [_hoisted_5];
                  }),
                  _: 2
                }, 1032, ["icon", "command", "disabled"]), _createVNode(_component_el_dropdown_item, {
                  icon: $setup.CircleClose,
                  command: {
                    num: 3,
                    path: tag,
                    index: index
                  }
                }, {
                  default: _withCtx(function () {
                    return [_hoisted_6];
                  }),
                  _: 2
                }, 1032, ["icon", "command"])];
              }),
              _: 2
            }, 1024)];
          }),
          default: _withCtx(function () {
            return [_createVNode(_component_el_tag, {
              class: _normalizeClass(["mx-1", _ctx.$route.name == tag.name ? 'bules' : '']),
              closable: "",
              size: "large",
              color: "#fff",
              onClick: function onClick($event) {
                return $options.tagCiclk(index);
              },
              onClose: function onClose($event) {
                return $options.deletes(index);
              }
            }, {
              default: _withCtx(function () {
                return [(_ctx.$route.name == tag.name ? true : false) ? (_openBlock(), _createBlock(_component_el_icon, {
                  key: 0,
                  style: {
                    "vertical-align": "middle"
                  }
                }, {
                  default: _withCtx(function () {
                    return [_createVNode(_component_location_filled)];
                  }),
                  _: 1
                })) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_3, _toDisplayString(tag.title), 1)];
              }),
              _: 2
            }, 1032, ["class", "onClick", "onClose"])];
          }),
          _: 2
        }, 1032, ["onCommand", "onContextmenu", "class"]);
      }), 128))])];
    }),
    _: 1
  })]);
}